// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ng-valid[required], .ng-valid.required  {
  border: 1px solid #3c763d;
}
.ng-touched.ng-invalid:not(form)  {
  border:1px solid red;
}
.errorDesc {
  border: 1px solid red;
}
.report-tab-content .form-group {
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.threeline{  padding-bottom: 0px !important;}
.text-danger{
  position: absolute;
  width: 94%;
}
.btn-cncl{

  background-color: #198094;
  border-radius: 35px;
  padding: 10px 24px;
  font-weight: bold;
  color: #fff;
  transition-duration: 0.3s;
  transition-property: transform;
  cursor: pointer;
  top: 2px;
}
.btn-orange {
  background-color: #F36324;
  border-radius: 15px;
  padding: 3px 12px;

  font-weight: bold;
  color: #fff;
  transition-duration: 0.3s;
  transition-property: transform;
  cursor: pointer;
}
.text-center{
  text-align: center !important;
}
/* .sideaa{margin-left: auto} */
#mySetting .modal-body{
  max-height: 350px;
  overflow-y: scroll;
}
.margin-top{margin-top: 7px}
.numberCircle {

border-radius:50%;
width:40px;
height:40px;
display:block;
float:left;
border:2px solid #000000;
color:#000000;
text-align:center;
margin-right:5px;
}
.form-control1{    display: block;
  border-radius: 18px;
  text-align: center;

  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;}

  .step5 .col-sm-12 {
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 50px;
}
.step4 .col-sm-12{
  width: 100%;

  align-items: center;
  min-height: 65px;
}
.step4 .control-label {
padding-top: 0px !important;
}
.step5 .col-sm-12 label{margin-bottom: 0px;}
#cancel{
      color: #fff;
    background-color: #9A0A35;
    border-color: #122b40
}
.plan-a {
  background: #00a6c6;
  padding: 16px 30px;
  color: #fff;
}
.outer-setting{width: 27px;height: 27px;float: right;background: #fff;border-radius: 50%;cursor: pointer;position: relative;
  top: -17px;}
.outer-setting span{position: relative;right: 4px;top: 4px;color: #00A6C6}
.rdesc{padding-top: 0;margin-top: -2px}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}
.bus-name .btn-primary {
border-color: #949599;
position: relative;
top: 34px;
left: -11px;    background-color: #fff;
}
.bg-white .glyphicon {

color: #949599;
}
/* .height-check{
  height: 90px;
} */
.client-name {
  color: #d6104c;
  font-weight: bold;
  width: 135px;
  float: right;
}
.client-name span {
  float: left;
  font-size: 13px;
  width: 100%;
  font-weight: normal;
  color: #949599;
}
.btn-gray {
  background-color: #999!important;
}

button#generateoutput {
    width: 14%;
}
.cncl-btn{FLOAT: RIGHT;
  background: #2184be;
  border-radius: 18px;
  COLOR: #FFF;}
  .cncl-btn a{color: #fff !important;    text-decoration: none;}
button#btnsave {
    /* color: pink; */
        color: #fff;
    background-color: #9A0A35;
    border-color: #122b40;
}
.navbar-nav>li>a{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  font-size: 13px;
  margin-left: -7px;
}
.nav>li>a>img {
  max-width: none;
  width: 32px;
  margin-right: 0px;
  margin-bottom: 3px;

}
.setting-icon{margin: 3px 3px 3px 0px;}
.text-align{display: inline-block; margin: 0 10px 0 0;}
.text-align a{color:#fff !important; font-weight: bold;cursor: pointer}
.outer-Newsetting{
  width: 22px;
  height: 21px;
  float: right;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  top: 0px;
}

:host ::ng-deep .popover {
color: red;
box-shadow: 0px 0px 0px 0px;
}

:host ::ng-deep .tab-pane .popover {
background-color: #ef8455;
color: #FFFFFF;
box-shadow: 0px 0px 0px 0px;

}


:host ::ng-deep .tab-pane .popover-input-field .popover {
background-color: #ef8455;
color: #FFFFFF;
box-shadow: 0px 0px 0px 0px;
top:-80px !important;
width:200px !important;
}

:host ::ng-deep .tab-pane .arrow:after {
border-top-color: #ef8455;
}


.create-report-tab li {
width: 25%;
}
.step4 .col-sm-2{width: 20%}
.step4 .form-group .col-sm-2 label{    text-align: center;
font-weight: normal !important;
min-height: 42px;
/* display: flex; */
align-items: flex-end;
justify-content: center;padding: 0 6px;}

.step5 .col-sm-2{width: 20%}
.step5 .form-group .col-sm-2 label{    text-align: center;
font-weight: normal !important;
min-height: 42px;
/* display: flex; */
align-items: flex-end;
justify-content: center;padding: 0 6px;}

.threeline label{    text-align: center;
font-weight: normal !important;
min-height: 51px ;}
.fourline label{    text-align: center;
  font-weight: normal !important;
  min-height: 80px !important;}

/* The container */
.container1 {
  display: inline-block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container1 input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container1:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container1 input:checked ~ .checkmark {
  background-color: #F36324;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container1 input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container1 .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.new-input{display: flex;justify-content: space-around;align-items: center;margin: 19px 0 0 22px;}
.new-input label{padding-top: 0px;}
.create-report-tab li > a{font-size: 16px}
.create-report-tab li {
width: 20%;
}
.control-label.col-sm-12{text-align: center;font-weight: normal;}
.tool-tip{text-decoration: none;color:#949599 }

.form-group label {
color: #949599;
font-size: 14px !important;
font-weight: normal;
text-align: left;
/* word-break: break-all; */
}
.btn-glyphicon {     padding: 2px;
color: #fff !important;
font-size: 22px;
margin-right: 4px; }
.icon-btn { padding: 3px 15px 5px 6px; border-radius:50px;display: inline-flex;
align-items: center;}
.tooltip.fade{display: block !important}
/* Tooltip */
.test{  text-decoration: none;    color: #949599;}

body {
margin: 0;
padding: 50px;
font: 400 14px/1.2em sans-serif;
background: white;
}

.nopadding{padding: 0}
.norightpadding{padding-right: 0}
.noleftpadding{padding-right: 0}
.chkbox label{margin-bottom: 12px !important;}

.business{padding: 11px 0px;margin-top: 8px;   margin-bottom: 3px;}
.currency-row{margin-left: 185px;margin-top: 10px;margin-bottom: 10px;}
.currency-note-row{margin-left: 175px;margin-top: 10px;margin-bottom: 10px;}
.currency-node-text{margin-left: 5px;}
.currency-note{color: #949599;
font-size: 14px !important;
font-weight: normal;
text-align: left;}

@media (max-width:1024px) and (min-width:768px) {
.form-group label {

  margin-bottom: 0;
}

.margin-top{
  margin-top: 0px;
}

.padtop{    margin-top: -16px;
  padding-top: 0;}

  .new-input {
    display: block;
    justify-content: space-around;
    align-items: center;margin-left: 20px;
}
.new-input label {

  float: left;
  text-align: left;
  width: 23%;
}
.new-input label:nth-of-type(5){margin-left: 0;}

}
@media (max-width:991px) and (min-width: 768px) {

.noleftpadding[_ngcontent-c6] {
  padding-right: 15px;
}

.norightpadding[_ngcontent-c6] {
padding-left: 0;
}


.step4 .control-label {
  padding-top: 0px !important;
  padding-left: 0;
}
.step4 .col-sm-12 {

  padding: 0;
}
.step5 .control-label {
  padding-top: 0px !important;
  padding-left: 0;
}
.step5 .col-sm-12 {

  padding: 0;
}

}

.form-control{
position:relative !important;
}

.btn-outer{
display: flex;
align-items: center;
justify-content: flex-end;

}
.btn-outer span{
position: relative;
border: 0px;
background: transparent;
overflow: hidden;
padding: 0;
margin: 0;
display:inline-flex
}

button#generateoutput {
width: auto;
}

span.label-text {
position: relative;
display: block;
border: 0;
color: #949599;
font-size: 14px !important;
font-weight: normal;
text-align: left;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
.reportErr{
  font-size: 10px;
}
}

`, "",{"version":3,"sources":["webpack://./src/app/data-input/data-input.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA,aAAa,8BAA8B,CAAC;AAC5C;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EAEzB,8BAA8B;EAE9B,eAAe;EACf,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;;EAEjB,iBAAiB;EACjB,WAAW;EAEX,yBAAyB;EAEzB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA,YAAY,eAAe;AAC3B;;AAEA,iBAAiB;AACjB,UAAU;AACV,WAAW;AACX,aAAa;AACb,UAAU;AACV,wBAAwB;AACxB,aAAa;AACb,iBAAiB;AACjB,gBAAgB;AAChB;AACA,mBAAmB,cAAc;EAC/B,mBAAmB;EACnB,kBAAkB;;EAElB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EAGtB,4CAA4C;EAG5C,qEAAqE,CAAC;;EAEtE;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;EACE,WAAW;;EAEX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;AACA,2BAA2B;AAC3B;AACA,wBAAwB,kBAAkB,CAAC;AAC3C;MACM,WAAW;IACb,yBAAyB;IACzB;AACJ;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA,eAAe,WAAW,CAAC,YAAY,CAAC,YAAY,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,eAAe,CAAC,kBAAkB;EACzH,UAAU,CAAC;AACb,oBAAoB,kBAAkB,CAAC,UAAU,CAAC,QAAQ,CAAC,cAAc;AACzE,OAAO,cAAc,CAAC,gBAAgB;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA;AACA,qBAAqB;AACrB,kBAAkB;AAClB,SAAS;AACT,WAAW,KAAK,sBAAsB;AACtC;AACA;;AAEA,cAAc;AACd;AACA;;GAEG;AACH;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA;IACI,UAAU;AACd;AACA,UAAU,YAAY;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW,CAAC;EACZ,YAAY,sBAAsB,KAAK,qBAAqB,CAAC;AAC/D;IACI,iBAAiB;QACb,WAAW;IACf,yBAAyB;IACzB,qBAAqB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;AAEpB;AACA,cAAc,uBAAuB,CAAC;AACtC,YAAY,qBAAqB,EAAE,kBAAkB,CAAC;AACtD,cAAc,qBAAqB,EAAE,iBAAiB,CAAC,eAAe;AACtE;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;AACA,UAAU;AACV,2BAA2B;AAC3B;;AAEA;AACA,yBAAyB;AACzB,cAAc;AACd,2BAA2B;;AAE3B;;;AAGA;AACA,yBAAyB;AACzB,cAAc;AACd,2BAA2B;AAC3B,oBAAoB;AACpB,sBAAsB;AACtB;;AAEA;AACA,yBAAyB;AACzB;;;AAGA;AACA,UAAU;AACV;AACA,iBAAiB,UAAU;AAC3B,uCAAuC,kBAAkB;AACzD,8BAA8B;AAC9B,gBAAgB;AAChB,mBAAmB;AACnB,qBAAqB;AACrB,uBAAuB,CAAC,cAAc,CAAC;;AAEvC,iBAAiB,UAAU;AAC3B,uCAAuC,kBAAkB;AACzD,8BAA8B;AAC9B,gBAAgB;AAChB,mBAAmB;AACnB,qBAAqB;AACrB,uBAAuB,CAAC,cAAc,CAAC;;AAEvC,qBAAqB,kBAAkB;AACvC,8BAA8B;AAC9B,iBAAiB,CAAC;AAClB,oBAAoB,kBAAkB;EACpC,8BAA8B;EAC9B,2BAA2B,CAAC;;AAE9B,kBAAkB;AAClB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAGzB,wBAAwB;AAC1B;AACA,WAAW,aAAa,CAAC,6BAA6B,CAAC,mBAAmB,CAAC,qBAAqB,CAAC;AACjG,iBAAiB,gBAAgB,CAAC;AAClC,0BAA0B,eAAe;AACzC;AACA,UAAU;AACV;AACA,yBAAyB,kBAAkB,CAAC,mBAAmB,CAAC;AAChE,UAAU,qBAAqB,CAAC,cAAc;;AAE9C;AACA,cAAc;AACd,0BAA0B;AAC1B,mBAAmB;AACnB,gBAAgB;AAChB,2BAA2B;AAC3B;AACA,qBAAqB,YAAY;AACjC,sBAAsB;AACtB,eAAe;AACf,iBAAiB,EAAE;AACnB,YAAY,yBAAyB,EAAE,kBAAkB,CAAC,oBAAoB;AAC9E,mBAAmB,CAAC;AACpB,cAAc,yBAAyB;AACvC,YAAY;AACZ,QAAQ,qBAAqB,KAAK,cAAc,CAAC;;AAEjD;AACA,SAAS;AACT,aAAa;AACb,+BAA+B;AAC/B,iBAAiB;AACjB;;AAEA,WAAW,UAAU;AACrB,gBAAgB,gBAAgB;AAChC,eAAe,gBAAgB;AAC/B,cAAc,8BAA8B,CAAC;;AAE7C,UAAU,iBAAiB,CAAC,eAAe,IAAI,kBAAkB,CAAC;AAClE,cAAc,kBAAkB,CAAC,gBAAgB,CAAC,mBAAmB,CAAC;AACtE,mBAAmB,kBAAkB,CAAC,gBAAgB,CAAC,mBAAmB,CAAC;AAC3E,oBAAoB,gBAAgB,CAAC;AACrC,eAAe,cAAc;AAC7B,0BAA0B;AAC1B,mBAAmB;AACnB,gBAAgB,CAAC;;AAEjB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,YAAY,iBAAiB;EAC3B,cAAc,CAAC;;EAEf;IACE,cAAc;IACd,6BAA6B;IAC7B,mBAAmB,CAAC,iBAAiB;AACzC;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA,gCAAgC,cAAc,CAAC;;AAE/C;AACA;;AAEA;EACE,mBAAmB;AACrB;;AAEA;AACA,eAAe;AACf;;;AAGA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;;AAEA;;AAEA;AACA,4BAA4B;AAC5B;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,yBAAyB;;AAEzB;AACA;AACA,kBAAkB;AAClB,WAAW;AACX,uBAAuB;AACvB,gBAAgB;AAChB,UAAU;AACV,SAAS;AACT;AACA;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,kBAAkB;AAClB,cAAc;AACd,SAAS;AACT,cAAc;AACd,0BAA0B;AAC1B,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;AACA;EACE,eAAe;AACjB;AACA","sourcesContent":[".ng-valid[required], .ng-valid.required  {\r\n  border: 1px solid #3c763d;\r\n}\r\n.ng-touched.ng-invalid:not(form)  {\r\n  border:1px solid red;\r\n}\r\n.errorDesc {\r\n  border: 1px solid red;\r\n}\r\n.report-tab-content .form-group {\r\n  padding-bottom: 25px;\r\n  margin-bottom: 0px;\r\n}\r\n.threeline{  padding-bottom: 0px !important;}\r\n.text-danger{\r\n  position: absolute;\r\n  width: 94%;\r\n}\r\n.btn-cncl{\r\n\r\n  background-color: #198094;\r\n  border-radius: 35px;\r\n  padding: 10px 24px;\r\n  font-weight: bold;\r\n  color: #fff;\r\n  transition-duration: 0.3s;\r\n  transition-property: -webkit-transform;\r\n  transition-property: transform;\r\n  transition-property: transform, -webkit-transform;\r\n  cursor: pointer;\r\n  top: 2px;\r\n}\r\n.btn-orange {\r\n  background-color: #F36324;\r\n  border-radius: 15px;\r\n  padding: 3px 12px;\r\n\r\n  font-weight: bold;\r\n  color: #fff;\r\n  -webkit-transition-duration: 0.3s;\r\n  transition-duration: 0.3s;\r\n  -webkit-transition-property: transform;\r\n  transition-property: transform;\r\n  cursor: pointer;\r\n}\r\n.text-center{\r\n  text-align: center !important;\r\n}\r\n/* .sideaa{margin-left: auto} */\r\n#mySetting .modal-body{\r\n  max-height: 350px;\r\n  overflow-y: scroll;\r\n}\r\n.margin-top{margin-top: 7px}\r\n.numberCircle {\r\n\r\nborder-radius:50%;\r\nwidth:40px;\r\nheight:40px;\r\ndisplay:block;\r\nfloat:left;\r\nborder:2px solid #000000;\r\ncolor:#000000;\r\ntext-align:center;\r\nmargin-right:5px;\r\n}\r\n.form-control1{    display: block;\r\n  border-radius: 18px;\r\n  text-align: center;\r\n\r\n  height: 34px;\r\n  padding: 6px 12px;\r\n  font-size: 14px;\r\n  line-height: 1.42857143;\r\n  color: #555;\r\n  background-color: #fff;\r\n  background-image: none;\r\n  border: 1px solid #ccc;\r\n\r\n  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\r\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\r\n  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;\r\n  -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\r\n  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;}\r\n\r\n  .step5 .col-sm-12 {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: 50px;\r\n}\r\n.step4 .col-sm-12{\r\n  width: 100%;\r\n\r\n  align-items: center;\r\n  min-height: 65px;\r\n}\r\n.step4 .control-label {\r\npadding-top: 0px !important;\r\n}\r\n.step5 .col-sm-12 label{margin-bottom: 0px;}\r\n#cancel{\r\n      color: #fff;\r\n    background-color: #9A0A35;\r\n    border-color: #122b40\r\n}\r\n.plan-a {\r\n  background: #00a6c6;\r\n  padding: 16px 30px;\r\n  color: #fff;\r\n}\r\n.outer-setting{width: 27px;height: 27px;float: right;background: #fff;border-radius: 50%;cursor: pointer;position: relative;\r\n  top: -17px;}\r\n.outer-setting span{position: relative;right: 4px;top: 4px;color: #00A6C6}\r\n.rdesc{padding-top: 0;margin-top: -2px}\r\n.btn-circle {\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  padding: 6px 0;\r\n  font-size: 12px;\r\n  line-height: 1.428571429;\r\n  border-radius: 15px;\r\n}\r\n.bus-name .btn-primary {\r\nborder-color: #949599;\r\nposition: relative;\r\ntop: 34px;\r\nleft: -11px;    background-color: #fff;\r\n}\r\n.bg-white .glyphicon {\r\n\r\ncolor: #949599;\r\n}\r\n/* .height-check{\r\n  height: 90px;\r\n} */\r\n.client-name {\r\n  color: #d6104c;\r\n  font-weight: bold;\r\n  width: 135px;\r\n  float: right;\r\n}\r\n.client-name span {\r\n  float: left;\r\n  font-size: 13px;\r\n  width: 100%;\r\n  font-weight: normal;\r\n  color: #949599;\r\n}\r\n.btn-gray {\r\n  background-color: #999!important;\r\n}\r\n\r\nbutton#generateoutput {\r\n    width: 14%;\r\n}\r\n.cncl-btn{FLOAT: RIGHT;\r\n  background: #2184be;\r\n  border-radius: 18px;\r\n  COLOR: #FFF;}\r\n  .cncl-btn a{color: #fff !important;    text-decoration: none;}\r\nbutton#btnsave {\r\n    /* color: pink; */\r\n        color: #fff;\r\n    background-color: #9A0A35;\r\n    border-color: #122b40;\r\n}\r\n.navbar-nav>li>a{\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n  padding-left: 0px;\r\n  font-size: 13px;\r\n  margin-left: -7px;\r\n}\r\n.nav>li>a>img {\r\n  max-width: none;\r\n  width: 32px;\r\n  margin-right: 0px;\r\n  margin-bottom: 3px;\r\n\r\n}\r\n.setting-icon{margin: 3px 3px 3px 0px;}\r\n.text-align{display: inline-block; margin: 0 10px 0 0;}\r\n.text-align a{color:#fff !important; font-weight: bold;cursor: pointer}\r\n.outer-Newsetting{\r\n  width: 22px;\r\n  height: 21px;\r\n  float: right;\r\n  background: #fff;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  position: relative;\r\n  top: 0px;\r\n}\r\n\r\n:host ::ng-deep .popover {\r\ncolor: red;\r\nbox-shadow: 0px 0px 0px 0px;\r\n}\r\n\r\n:host ::ng-deep .tab-pane .popover {\r\nbackground-color: #ef8455;\r\ncolor: #FFFFFF;\r\nbox-shadow: 0px 0px 0px 0px;\r\n\r\n}\r\n\r\n\r\n:host ::ng-deep .tab-pane .popover-input-field .popover {\r\nbackground-color: #ef8455;\r\ncolor: #FFFFFF;\r\nbox-shadow: 0px 0px 0px 0px;\r\ntop:-80px !important;\r\nwidth:200px !important;\r\n}\r\n\r\n:host ::ng-deep .tab-pane .arrow:after {\r\nborder-top-color: #ef8455;\r\n}\r\n\r\n\r\n.create-report-tab li {\r\nwidth: 25%;\r\n}\r\n.step4 .col-sm-2{width: 20%}\r\n.step4 .form-group .col-sm-2 label{    text-align: center;\r\nfont-weight: normal !important;\r\nmin-height: 42px;\r\n/* display: flex; */\r\nalign-items: flex-end;\r\njustify-content: center;padding: 0 6px;}\r\n\r\n.step5 .col-sm-2{width: 20%}\r\n.step5 .form-group .col-sm-2 label{    text-align: center;\r\nfont-weight: normal !important;\r\nmin-height: 42px;\r\n/* display: flex; */\r\nalign-items: flex-end;\r\njustify-content: center;padding: 0 6px;}\r\n\r\n.threeline label{    text-align: center;\r\nfont-weight: normal !important;\r\nmin-height: 51px ;}\r\n.fourline label{    text-align: center;\r\n  font-weight: normal !important;\r\n  min-height: 80px !important;}\r\n\r\n/* The container */\r\n.container1 {\r\n  display: inline-block;\r\n  position: relative;\r\n  padding-left: 35px;\r\n  margin-bottom: 12px;\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n/* Hide the browser's default checkbox */\r\n.container1 input {\r\n  position: absolute;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Create a custom checkbox */\r\n.checkmark {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 25px;\r\n  width: 25px;\r\n  background-color: #eee;\r\n}\r\n\r\n/* On mouse-over, add a grey background color */\r\n.container1:hover input ~ .checkmark {\r\n  background-color: #ccc;\r\n}\r\n\r\n/* When the checkbox is checked, add a blue background */\r\n.container1 input:checked ~ .checkmark {\r\n  background-color: #F36324;\r\n}\r\n\r\n/* Create the checkmark/indicator (hidden when not checked) */\r\n.checkmark:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\n/* Show the checkmark when checked */\r\n.container1 input:checked ~ .checkmark:after {\r\n  display: block;\r\n}\r\n\r\n/* Style the checkmark/indicator */\r\n.container1 .checkmark:after {\r\n  left: 9px;\r\n  top: 5px;\r\n  width: 5px;\r\n  height: 10px;\r\n  border: solid white;\r\n  border-width: 0 3px 3px 0;\r\n  -webkit-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n  transform: rotate(45deg);\r\n}\r\n.new-input{display: flex;justify-content: space-around;align-items: center;margin: 19px 0 0 22px;}\r\n.new-input label{padding-top: 0px;}\r\n.create-report-tab li > a{font-size: 16px}\r\n.create-report-tab li {\r\nwidth: 20%;\r\n}\r\n.control-label.col-sm-12{text-align: center;font-weight: normal;}\r\n.tool-tip{text-decoration: none;color:#949599 }\r\n\r\n.form-group label {\r\ncolor: #949599;\r\nfont-size: 14px !important;\r\nfont-weight: normal;\r\ntext-align: left;\r\n/* word-break: break-all; */\r\n}\r\n.btn-glyphicon {     padding: 2px;\r\ncolor: #fff !important;\r\nfont-size: 22px;\r\nmargin-right: 4px; }\r\n.icon-btn { padding: 3px 15px 5px 6px; border-radius:50px;display: inline-flex;\r\nalign-items: center;}\r\n.tooltip.fade{display: block !important}\r\n/* Tooltip */\r\n.test{  text-decoration: none;    color: #949599;}\r\n\r\nbody {\r\nmargin: 0;\r\npadding: 50px;\r\nfont: 400 14px/1.2em sans-serif;\r\nbackground: white;\r\n}\r\n\r\n.nopadding{padding: 0}\r\n.norightpadding{padding-right: 0}\r\n.noleftpadding{padding-right: 0}\r\n.chkbox label{margin-bottom: 12px !important;}\r\n\r\n.business{padding: 11px 0px;margin-top: 8px;   margin-bottom: 3px;}\r\n.currency-row{margin-left: 185px;margin-top: 10px;margin-bottom: 10px;}\r\n.currency-note-row{margin-left: 175px;margin-top: 10px;margin-bottom: 10px;}\r\n.currency-node-text{margin-left: 5px;}\r\n.currency-note{color: #949599;\r\nfont-size: 14px !important;\r\nfont-weight: normal;\r\ntext-align: left;}\r\n\r\n@media (max-width:1024px) and (min-width:768px) {\r\n.form-group label {\r\n\r\n  margin-bottom: 0;\r\n}\r\n\r\n.margin-top{\r\n  margin-top: 0px;\r\n}\r\n\r\n.padtop{    margin-top: -16px;\r\n  padding-top: 0;}\r\n\r\n  .new-input {\r\n    display: block;\r\n    justify-content: space-around;\r\n    align-items: center;margin-left: 20px;\r\n}\r\n.new-input label {\r\n\r\n  float: left;\r\n  text-align: left;\r\n  width: 23%;\r\n}\r\n.new-input label:nth-of-type(5){margin-left: 0;}\r\n\r\n}\r\n@media (max-width:991px) and (min-width: 768px) {\r\n\r\n.noleftpadding[_ngcontent-c6] {\r\n  padding-right: 15px;\r\n}\r\n\r\n.norightpadding[_ngcontent-c6] {\r\npadding-left: 0;\r\n}\r\n\r\n\r\n.step4 .control-label {\r\n  padding-top: 0px !important;\r\n  padding-left: 0;\r\n}\r\n.step4 .col-sm-12 {\r\n\r\n  padding: 0;\r\n}\r\n.step5 .control-label {\r\n  padding-top: 0px !important;\r\n  padding-left: 0;\r\n}\r\n.step5 .col-sm-12 {\r\n\r\n  padding: 0;\r\n}\r\n\r\n}\r\n\r\n.form-control{\r\nposition:relative !important;\r\n}\r\n\r\n.btn-outer{\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: flex-end;\r\n\r\n}\r\n.btn-outer span{\r\nposition: relative;\r\nborder: 0px;\r\nbackground: transparent;\r\noverflow: hidden;\r\npadding: 0;\r\nmargin: 0;\r\ndisplay:inline-flex\r\n}\r\n\r\nbutton#generateoutput {\r\nwidth: auto;\r\n}\r\n\r\nspan.label-text {\r\nposition: relative;\r\ndisplay: block;\r\nborder: 0;\r\ncolor: #949599;\r\nfont-size: 14px !important;\r\nfont-weight: normal;\r\ntext-align: left;\r\n}\r\n\r\n@media only screen and (min-width: 768px) and (max-width: 991px) {\r\n.reportErr{\r\n  font-size: 10px;\r\n}\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
